import { jsxs as _jsxs } from "react/jsx-runtime";
import { StyledText } from '../styles/text';
import { colors } from '../styles/theme';
import translations from './lang';
/**
 * This finds a string from <language>.json, then replaces its slots with values, returning a fully formatted string for the UI.
 * @param {Object} lookup Object that has key of the string from <language>.json
 * @param {Object} data Values of slots to replace.  Key is slot, value is replacement.
 */
const i18n = (currentLanguage) => (translation, values) => {
    const strings = translations[currentLanguage];
    const keys = translation.split('.');
    const messageKey = keys[0];
    const message = keys[1];
    let result;
    if (typeof message === 'string' &&
        Object.keys(strings).includes(messageKey)) {
        result = strings[messageKey][message];
    }
    else {
        result = (_jsxs(StyledText, { color: colors.error, children: ["Invalid translation key: ", messageKey] }));
    }
    if (typeof result !== 'string') {
        result = (_jsxs(StyledText, { color: colors.error, children: ["Missing translation for: ", translation] }));
    }
    if (values) {
        const pattern = /\{\{(\w+)\}\}/;
        if (pattern.test(result)) {
            result = result.toString().replace(pattern, (_, placeholder) => {
                return values[placeholder];
            });
        }
        else {
            result = (_jsxs(StyledText, { color: colors.error, children: ["Missing ", Object.keys(values), " placeholder for: ", translation] }));
        }
    }
    return result;
};
export default i18n;
//# sourceMappingURL=i18n.js.map